jQuery_custom(document).ready(function() {
  var ENDPOINT = {
    "de": '/de/blutspendetermine/terminbuttons/cities',
    "fr": '/fr/dates-de-collecte-de-sang/boutons-de-dates-de-collecte/cities',
    "it": '/it/date-per-la-donazione-di-sangue/pulsanti-delle-date/cities',
    "en": '/en/blood-donation-appointments/appointment-buttons/cities'
  }

  var city_input = jQuery_custom('.city-autocomplete');
  city_input.autocomplete({
    source: function (request, response) {
      jQuery_custom.getJSON(ENDPOINT[city_input.data('locale')], {
        city_search: {
          term: request.term,
        }
      }, function (res) {
        response(res.map(function (val) {
          return { label: val, value: val }
        }))
      })
    }
  });
});
